import { Children } from 'react';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import { Icon } from '../../display/Icon/Icon.es.js';

const Styles = labelStyles("Breadcrumbs", {
  root: css`
    color: ${Colors.GrayWarm10};
    &[data-size='large'] {
      ${Typography.Body3};
    }
    &[data-size='small'] {
      ${Typography.SmallPrint3};
    }
  `,
  list: css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--zds-space-2, 2px) var(--zds-space-0, 0px);
  `,
  item: css`
    display: flex;
    align-items: inherit;
    gap: inherit;
  `
});
const Breadcrumbs = ({ children, size = "large" }) => {
  const iconSize = {
    small: 20,
    large: 24
  }[size];
  const items = Children.toArray(children).filter(Boolean).map((link, i, links) => {
    const icon = i !== links.length - 1 && jsx(
      "span",
      { "aria-hidden": "true", "data-zds": true },
      jsx(Icon, { css: Styles.icon, isBlock: true, color: "GrayWarm4", name: "arrowSmallRight", size: iconSize })
    );
    return jsx(
      "li",
      { css: Styles.item, key: i, "data-zds": true },
      link,
      icon
    );
  });
  return jsx(
    "div",
    { css: Styles.root, "data-size": size, "data-zds": true },
    jsx("ol", { css: Styles.list, "data-zds": true }, items)
  );
};

export { Breadcrumbs };
//# sourceMappingURL=Breadcrumbs.es.js.map
